import styled from '@emotion/styled';
import { layout } from '@modernhealth/vital-foundation';

export const PageContentContainer = styled.div<{ width?: string | number }>(
    ({ width = layout.containerWidth }) => ({
        width: '100%',
        maxWidth: width,
        margin: '0 auto',
        padding: 21,
    }),
);
